import ListDocumentsCandidates from './ListDocumentsCandidates';

export default ListDocumentsCandidates;
